var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { FiChevronDown, FiChevronUp } from "react-icons/fi";

var Container = styled.div.withConfig({
  displayName: "CollapsableBox__Container",
  componentId: "v7boiy-0"
})(["margin:0 auto;background:", ";border:2px solid #e7e7e7;border-radius:0.75em;&:not(:first-of-type){margin-top:1rem;}"], function (_ref) {
  var background = _ref.background,
      theme = _ref.theme;
  return background ? theme[background] : "white";
});

var HeaderContainer = styled.div.withConfig({
  displayName: "CollapsableBox__HeaderContainer",
  componentId: "v7boiy-1"
})(["cursor:", ";display:flex;justify-content:space-between;align-items:center;padding:1em 1.5em;"], function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled && "pointer";
});

var InfoContainer = styled.div.withConfig({
  displayName: "CollapsableBox__InfoContainer",
  componentId: "v7boiy-2"
})(["padding:0 1.5em 1em 1.5em;"]);

var IconChevronDown = styled(FiChevronDown).withConfig({
  displayName: "CollapsableBox__IconChevronDown",
  componentId: "v7boiy-3"
})(["width:2em;height:2em;"]);

var IconChevronUp = styled(FiChevronUp).withConfig({
  displayName: "CollapsableBox__IconChevronUp",
  componentId: "v7boiy-4"
})(["width:2em;height:2em;"]);

var _default = (_temp2 = _class = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _this.showContent = function () {
      _this.setState(function (prev) {
        return { visible: !prev.visible };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.render = function render() {
    var visible = this.state.visible;

    return React.createElement(
      Container,
      null,
      React.createElement(
        HeaderContainer,
        {
          onClick: this.showContent,
          background: this.props.background,
          disabled: this.props.disabled
        },
        React.createElement(
          "div",
          null,
          this.props.children
        ),
        visible ? React.createElement(IconChevronUp, null) : React.createElement(IconChevronDown, null)
      ),
      visible && !this.props.disabled && React.createElement(
        InfoContainer,
        null,
        this.props.content
      )
    );
  };

  return _default;
}(React.Component), _class.propTypes = {
  content: PropTypes.element,
  disabled: PropTypes.bool
}, _temp2);

export { _default as default };